import {Component, ElementRef, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {CommonComponent} from '../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {LocalStorageService} from 'angular-2-local-storage';
import {AuthenticationService} from '../../services/authentication.service';
import {Profile} from '../../domain/authentication/profile';
import {StorageItem} from '../../enums/storage-item';
import {ConfigurationService} from '../../services/configuration.service';
import {environment} from '../../../environments/environment';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent extends CommonComponent implements OnInit {
  namespace = environment.namespace;
  url = environment.homeEndpoint.slice(8);
  bgColor = environment.main.bgColor;
  navbarWhiteIcon = environment.main.navbarWhiteIcon;
  textColor = environment.main.textColor;
  reloadCardBg = environment.main.reloadCardBg;
  es = environment.es;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected dialogService: DialogService,
    private localStorage: LocalStorageService,
    private element: ElementRef,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
    public configurationService: ConfigurationService,
    router: Router
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configurationService.clearConfigurations();
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    if (this.locale && profile){
      profile.locale = this.locale;
    }
    if (profile?.locale) {
      translate.use(this.getValidLanguage(profile.locale.substring(0, 2)));
    } else {
      translate.use(this.getValidLanguage(window.location.pathname.substring(1, 3)));
    }
  }

  ngOnInit(): void {
    this.configurationService.getPlatformConfig();
  }

  navChangeLink(event) {
    const elem = this.element.nativeElement.querySelector('.active');
    if (elem) {
      elem.classList.remove('active');
    }
    event.target.classList.add('active');
  }

  scrollToContact(event: Event) {
    event.preventDefault();
    this.navChangeLink(event);

    const scrollToSection = () => {
      const CONTACT_SECTION = document.getElementById('contact-us');
      if (CONTACT_SECTION) {
        CONTACT_SECTION.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (this.router.url !== '/') {
      const NAVIGATE$: Subscription = this.router.events
        .pipe(filter((end): end is NavigationEnd => end instanceof NavigationEnd))
        .subscribe(() => {
          setTimeout(() => {
            scrollToSection();
            NAVIGATE$.unsubscribe();
          }, 100);
        });

      this.router.navigate(['/']);
    } else {
      scrollToSection();
    }
  }

  navigationScrollin(event: Event, urlParam: string) {
    this.navChangeLink(event);
    event.preventDefault();

    const NAVIGATION$ = this.router.events.subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      NAVIGATION$.unsubscribe();
    });

    this.router.navigate([urlParam]);
  }

  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {
    });
  }

  changeLanguage(language: string) {
    this.authenticationService.setLocale(language);
    this.translate.use(this.getValidLanguage(language)).subscribe(
      response => {
        if (this.useOldTranslation()) {
          window.location.href = `/${language}${this.getCurrentRoute()}`;
        }
      }
    );
  }

  getCurrentRoute() {
    return this.router.url;
  }

  useOldTranslation(): boolean {
    if (this.router.url.includes('personalData') || this.router.url.includes('broker') || this.router.url.includes('photos') ||
      this.router.url.includes('additionalIdentification') || this.router.url.includes('additionalQuestions') || this.router.url.includes('preApproved') ||
      this.router.url.includes('contracts') || this.router.url.includes('referred') || this.router.url.includes('usaIds') ||
      this.router.url.includes('signature') || this.router.url.includes('addReferrer') || this.router.url.includes('contactData') ||
      this.router.url.includes('end') ||
      this.router.url.includes('resetPass') || this.router.url.includes('emailConfirmation') || this.router.url.includes('mobileApp') ||
      this.router.url.includes('selfie') ||
      this.router.url.includes('conditions') || // tiene un componente de privacy notices al final y ese todavía usa las viejas traducciones.
      this.router.url.includes('aboutUs') || this.router.url.includes('login') ||
      this.router.url.includes('passwordRecovery') || this.router.url.includes('remittanceConditions') ||
      this.router.url.includes('remittancePrivacy') || this.router.url == '/' ||
      this.router.url.includes('faq') || this.router.url.includes('privacy')

    ) {
      return false;
    } else {
      return true;
    }
  }
  scrollToComponent() {
    this.router.navigate(['/']);
    setTimeout(() => {
      const element = this.element.nativeElement.querySelector('#targetElement');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
        element.style.backgroundColor = 'var(--primary)';
      }
    }, 100);
  }

}
